// src/components/AdminDashboard/AdminDashboard.js
import React, { useState, useEffect } from "react";
import BadgeAdmin from "./BadgeAdmin";
import UserTable from "./UserTable";
import FeedbackManagement from "./FeedbackManagement";
import NotificationManagement from "./NotificationManagement";
import TabNavigation from "./TabNavigation";
import logger from "../../utils/logger";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("users");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/all?t=${Date.now()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateUserRole = async (userId, newRole) => {
    try {
      const userData = JSON.parse(localStorage.getItem("user")) || {};
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ role: newRole }),
        }
      );

      if (response.ok) {
        fetchUsers();
        alert("User role updated successfully!");
      } else {
        const error = await response.json();
        alert(error.error || "Error updating role");
      }
    } catch (error) {
      alert("Error updating user role");
    }
  };

  const updateStudentMatches = async (userId, matches) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ studentMatchesRemaining: matches }),
        }
      );

      if (response.ok) {
        fetchUsers();
        alert("Student matches updated successfully!");
      } else {
        const error = await response.json();
        alert(error.error || error.message || "Error updating matches");
      }
    } catch (error) {
      console.error("Error updating student matches:", error);
      alert(`Error updating student matches: ${error.message}`);
    }
  };

  const deleteUser = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const token = localStorage.getItem("token");
      logger.log("Attempting to delete user");
      logger.log("Token validation:", token ? "Valid" : "Invalid");

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        fetchUsers();
        alert("User deleted successfully!");
      } else {
        const errorText = await response.text();
        try {
          const error = JSON.parse(errorText);
          alert(error.error || "Error deleting user");
        } catch {
          alert(`Error deleting user: ${response.status} - ${errorText}`);
        }
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert(`Network error deleting user: ${error.message}`);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>
      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
      {activeTab === "users" && (
        <UserTable
          users={users}
          updateUserRole={updateUserRole}
          deleteUser={deleteUser}
          updateStudentMatches={updateStudentMatches}
          refreshUsers={fetchUsers}
        />
      )}
      {activeTab === "badges" && <BadgeAdmin />}
      {activeTab === "feedback" && <FeedbackManagement />}
      {activeTab === "notifications" && <NotificationManagement />}
    </div>
  );
};

export default AdminDashboard;
